import { configureStore } from "@reduxjs/toolkit";

import appReducer from "store/slices/appSlice";
import authReducer from "store/slices/authSlice";

export const store = configureStore({
  reducer: {
    app: appReducer,
    auth: authReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
